export default __webpack_public_path__ + "static/media/360px-220px-square-PMR-Dev-no-border.17fba61d.jpg";